import React from 'react';
const Hidden: React.SFC<{ dontShowCol: true }> = (props) => <div style={{ display: 'none' }}>{props.children}</div>;
export default Hidden;
